
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7221/api/',

    //Live
    //apiUrl: 'https://rah-api.solegaze.com/api/',

    //DEMO
     apiUrl: 'https://vat-api.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

